<template>
  <!-- 无评估体系考核时间下拉框  -->
  <div class="my-selector">
    <div :class="{'my-label': !disabled, 'disabled': disabled}">
      {{ myLabel }}
    </div>
    <div v-if="disabled" style="margin-left: 5px;font-size: 12px;">{{ data['examineMonth'] }}</div>
    <el-select v-else v-model="data['examineMonth']" style="width: 100%;">
      <el-option
        v-for="item of examineMonthOps"
        :key="item['value']"
        :value="item['value']"
        :label="item['label']"
        style="width: 50%"
      />
    </el-select>
  </div>
</template>

<script>
import http from '@/plugin/axios'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      examineMonthOps: [],
      workingPeriod: '1',
      mapParam: {
        '1': 'examineMonthName',
        '2': 'examineQuarterName',
        '3': 'examineHalfYearName',
        '4': 'examineYearName'
      }
    }
  },
  computed: {
    myLabel() {
      return this.$t('performanceAppraisal.performanceAppraisal.myLabel[' + (Number(this.workingPeriod) - 1) + ']')
    }
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        if (!this.disabled && (oldVal === undefined || newVal.workingPeriod !== this.workingPeriod)) {
          this.workingPeriod = newVal.workingPeriod
          this.getExamineMonthOps(this.mapParam[newVal.workingPeriod])
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if (this.disabled) {
      this.workingPeriod = this.data.workingPeriod
    }
  },
  methods: {
    getExamineMonthOps(workingPeriod) {
      this.apiPeriod(workingPeriod).then(res => {
        if (res && res.length > 0) {
          this.examineMonthOps = res.map(item => {
            return { label: item.enumName, value: item.enumValue }
          })
          this.data.examineMonth = this.examineMonthOps[0].value
        }
      })
    },
    apiPeriod(workingPeriod) {
      return http({
        url: '/sysEnum/getEnumByType',
        baseURL: process.env.VUE_APP_BASE_DATA_API,
        data: {
          enumMid: workingPeriod
        },
        loading: false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.my-selector {
  width: 32.6%;
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  .my-label {
    width: 72px;
    font-family: "Microsoft YaHei", serif;
    font-weight: 400;
    font-size: 12px;
    color: #333;
    &:before {
      content: '*';
      color: #de0010;
      margin-right: 2px;
    }
  }
  .disabled {
    width: 50px;
    font-family: "Microsoft YaHei", serif;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    margin-left: 10px;
  }
}
</style>
